import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {SoldPolicy} from '../interface/sold-policy';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {first} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';

@Injectable({
  providedIn: 'root'
})
export class SoldPolicyService {
  public readonly policyListSubject: ReplaySubject<CountedAndPaginated<SoldPolicy>>
    = new ReplaySubject<CountedAndPaginated<SoldPolicy>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/sold-policy?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<SoldPolicy>) => {
        this.policyListSubject.next(result);
      });
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/sold-policy/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public createReport(formData: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/sold-policy/method/createReport`, formData)
      .pipe(first()) as Observable<Uuid>;
  }

}
